(function() {
  // Get the active color value for a given product-card
  function getActiveColor(cardEl) {
  const sizeWrap = cardEl.querySelector('[data-quick-sizes]');
  if (!sizeWrap) return '__default__';

  // Read color keys from any size button's variant map
  const firstBtn = sizeWrap.querySelector('.product-card__quick-size-btn');
  let colorKeys = [];
  if (firstBtn) {
    try { colorKeys = Object.keys(JSON.parse(firstBtn.dataset.variantMap)); } catch (e) {}
  }

  // Single-color products: there's only one option, use it
  if (colorKeys.length === 1) {
    return colorKeys[0];
  }

  // Multi-color products: find the checked radio whose value is a known color
  const checkedRadios = cardEl.querySelectorAll('.variant-option-radio-input:checked');
  for (const radio of checkedRadios) {
    if (colorKeys.includes(radio.value)) {
      return radio.value;
    }
  }

  // Fallback (shouldn't normally hit this)
  return sizeWrap.dataset.defaultColor || '__default__';
}

  // Update size button states based on currently-selected color
  function syncSizeButtons(cardEl) {
    const sizeWrap = cardEl.querySelector('[data-quick-sizes]');
    if (!sizeWrap) return;
    const color = getActiveColor(cardEl);
    sizeWrap.querySelectorAll('.product-card__quick-size-btn').forEach(btn => {
      let map = {};
      try { map = JSON.parse(btn.dataset.variantMap); } catch (e) {}
      const entry = map[color] || map['__default__'];
      if (entry && entry.available) {
        btn.disabled = false;
        btn.dataset.activeVariantId = entry.id;
      } else {
        btn.disabled = true;
        delete btn.dataset.activeVariantId;
      }
    });
  }

  // Build the section list to request from /cart/add.js using Release's pattern
  function getSectionsToRequest() {
    const sections = [];
    const mainCartId = document.getElementById('main-cart-items')?.dataset.id;
    if (mainCartId) sections.push(mainCartId);
    sections.push('cart-counter');
    if (document.querySelector('cart-drawer')) sections.push('cart-drawer');
    return sections;
  }

  // AJAX add + tell Release's cart-drawer to refresh and open
  async function addVariantToCart(variantId) {
    const sections = getSectionsToRequest();
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1 }],
        sections: sections.join(','),
        sections_url: window.location.pathname
      })
    });

    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || err.message || 'Add to cart failed');
    }

    const response = await res.json();

    // Use Release's own cart-drawer API: renderContents updates the drawer HTML and opens it
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      cartDrawer.renderContents(response, true);
    } else {
      // No drawer on this page (e.g., /cart) — just reload to reflect the new item
      window.location.reload();
    }

    // Free-shipping bar isn't part of renderContents; ping it manually if available
    if (typeof updateFreeShipping === 'function') {
      updateFreeShipping();
    }
  }

  // Initialize all cards on page load
  function initAll() {
    document.querySelectorAll('product-card').forEach(syncSizeButtons);
  }

  // Re-sync size buttons whenever a color swatch is changed
  document.addEventListener('change', (e) => {
    if (e.target.matches('.variant-option-radio-input')) {
      const card = e.target.closest('product-card');
      if (card) syncSizeButtons(card);
    }
  });

  // Handle size button clicks → AJAX add to cart
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.product-card__quick-size-btn');
  if (!btn || btn.disabled) return;
  e.preventDefault();
  e.stopPropagation();

  const variantId = btn.dataset.activeVariantId;
  if (!variantId) return;

  const card = btn.closest('product-card');
  const label = card?.querySelector('[data-quick-sizes-label]');
  const labelDefault = label?.dataset.defaultText || label?.textContent || 'Add to cart';
  if (label && !label.dataset.defaultText) label.dataset.defaultText = labelDefault;

  btn.classList.add('is-loading');
  const originalText = btn.textContent;
  btn.textContent = '…';
  if (label) {
    label.textContent = 'Adding…';
    label.classList.add('is-loading');
    label.classList.remove('is-success');
  }

  try {
    await addVariantToCart(variantId);
    btn.textContent = '✓';
    if (label) {
      label.textContent = 'Added to cart';
      label.classList.remove('is-loading');
      label.classList.add('is-success');
    }
    setTimeout(() => {
      btn.textContent = originalText;
      btn.classList.remove('is-loading');
      if (label) {
        label.textContent = labelDefault;
        label.classList.remove('is-success');
      }
    }, 1500);
  } catch (err) {
    console.error('[quick-sizes]', err);
    btn.textContent = '!';
    btn.title = err.message || 'Error';
    if (label) {
      label.textContent = 'Error — try again';
      label.classList.remove('is-loading');
    }
    setTimeout(() => {
      btn.textContent = originalText;
      btn.classList.remove('is-loading');
      if (label) {
        label.textContent = labelDefault;
      }
    }, 1800);
  }
});

  // Boot
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init after Shopify section reloads in the theme editor
  document.addEventListener('shopify:section:load', initAll);
})();